export default "__VITE_ASSET__4f9b79c0__"